import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { searchFormConfig } from './config/search.config'
import { downloadData, getListData } from '@/service/main/system'
import { usePageSearch } from '@/hooks/userPageSearch'
import { contentTableConfig } from './config/content.config'
import { usePageModal } from '@/hooks/usePageModal'
import { modalConfig } from './config/modal.config'
import { reactive, ref } from 'vue'
import { useStore } from '@/store'
import { Excel } from '@/utils/ExcelJs'
import { ElNotification, ElMessage, ElLoading } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'HotStock',
  setup(__props) {

const store = useStore()


const modalTitle = ref('新增')
const plateList = ref<any>([])
const getPlates = async () => {
  plateList.value = await getListData('/main/stock/getPlates', {})
  const plateOptions = plateList.value.map((item: any) => {
    return {title: item, value: item};
  })
  const plateItem = searchFormConfig.formItems.find((item) => item.field === 'plateName')
  plateItem!.options = plateOptions;
  // getTag()
}
 getPlates()
const getTag = async () => {
  let tagList = await getListData('/main/stock/getTagsByPlate', {plateName: plateList.value[0]})
  const tagOptions = tagList.map((item: any) => {
    return {title: item, value: item};
  })
  const tagItem = searchFormConfig.formItems.find((item) => item.field === 'stockTag')
  tagItem!.options = tagOptions;
}

const newCb = () => {
  modalTitle.value = '新增股票'
   modalConfig.formItems.forEach((item) => {
    item.isDisabled = false
  })
}

const editCb = (item: any) => {
  modalTitle.value = '编辑股票'
  modalConfig.formItems.forEach((item) => {
   if (item.field === 'stockCode') {
      item.isDisabled = true
    } else {
      item.isDisabled = false
    }
  })
}
const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}
const handleDownloadImport = () => {
  const fileName = '热点强股上传模板.xlsx'
  downloadData(
    '/main/stock/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}
let loadingInstance = ref<any>()
const handleImportProgress = (res: any) => {
  loadingInstance.value = ElLoading.service({
    lock: true,
    text: '导入数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
const handleImportSuccess = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    if(res && res.code){
      ElMessage({
        type: 'warning',
        message: res.message
      })
    }else{
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
      handleSearchClick()
    }
  }
}

const handleImportError = (res: any) => {
  // 解绑事件时关闭Loading
  if (loadingInstance.value) {
    loadingInstance.value.close(); // 关闭Loading实例
  }
  ElMessage({
    type: 'error',
    message: res.message
  })
}


const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch()
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "stock",
      deleteTip: "确认删除吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData),
      onYbwaveDownloadImport: handleDownloadImport,
      onImportProgress: handleImportProgress,
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError,
      onSortChange: handleSortChange
    }, {
      rate: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({color: scope.row.rate > 0 ? '#dc362e':scope.row.rate < 0 ? '#107c10' : '#333' } )
        }, _toDisplayString(scope.row.rate == null ? null: (scope.row.rate * 100).toFixed(2)+'%'), 5)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "stock"
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ], 64))
}
}

})